<template>
    <section>
        <router-view />
    </section>
</template>

<script>
   

    export default {
        name: 'ui-products-digital-mirror',
    }
</script>